import { render } from "./ProfileKuwa.vue?vue&type=template&id=6c27500c&scoped=true"
import script from "./ProfileKuwa.vue?vue&type=script&lang=js"
export * from "./ProfileKuwa.vue?vue&type=script&lang=js"

import "./ProfileKuwa.vue?vue&type=style&index=0&id=6c27500c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c27500c"]])

export default __exports__